<template>
  <Modal width="500" v-model="show" :loading="loading" @on-ok="ok" @on-cancel="cancel">
    <h3 slot="header" class="modal-header">审核管家说</h3>
    <Form
      class="zotalk_check"
      ref="formData"
      :model="formData"
      :rules="ruleValidate"
      :label-width="105"
    >
      <Row>
        <Col span="20">
          <FormItem prop="auditStatus" label="审核结果：">
            <RadioGroup v-model="formData.auditStatus">
              <Radio :label="'1'">
                <span>通过</span>
              </Radio>
              <Radio :label="'2'">
                <span>拒绝</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row v-if="formData.auditStatus==1">
        <Col span="16">
          <FormItem prop="isShow" label="显隐状态：">
            <RadioGroup v-model="formData.isShow">
              <Radio :label="'1'">
                <span>显示</span>
              </Radio>
              <Radio :label="'0'">
                <span>隐藏</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row v-if="formData.auditStatus==='2'">
        <Col span="18">
          <FormItem prop="auditRemark" label="审核备注：">
            <Input
              :maxlength="14"
              :show-word-limit="true"
              v-model.trim="formData.auditRemark"
              type="textarea"
            ></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import { updateStatus } from "../../../../api/evaluation";
import { mapGetters } from "vuex";
export default {
  props: {
    n: {
      type: Number,
      default: 0
    },
    fid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: true,
      show: false,
      formData: {
        auditStatus: "",
        isShow: "",
        auditRemark: ""
      },
      ruleValidate: {
        auditStatus: [
          { required: true, message: "请选择审核结果", trigger: "change" }
        ],
        isShow: [
          { required: true, message: "请选择显隐状态", trigger: "change" }
        ],
        auditRemark: [
          { required: true, message: "请填写审核备注", trigger: "blur" },
          {
            validator: (rule, value, cb) => {
              this.lenValid(value, 4, cb);
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["empCode"])
  },
  watch: {
    n() {
      this.show = true;
      this.formData = {
        auditStatus: "",
        isShow: "",
        auditRemark: ""
      };
      this.$refs["formData"].resetFields();
    }
  },
  methods: {
	   lenValid(str, num, cb){
    if(str){
        const len = str.replace(/\s+/g, "").length
        if(len < num){
            return cb(new Error('字数填写不够，请输入最少4个汉字'))
        }
    }
    cb()
},



    updateStatus(data = {}) {
      Object.assign(
        data,
        { fid: this.fid, auditEmp: this.empCode },
        this.formData
      );
      updateStatus(data)
        .then(res => {
          if (res.code === 0) {
            this.$Message.success("审核成功");
            setTimeout(() => {
              this.$emit("refresh");
            }, 1000);
          } else {
            this.$Message.info(res.message);
          }
        })
        .catch(e => {
          this.$Message.info("审核失败");
        })
        .finally(() => {
          this.show = false;
          this.changeLoading();
        });
    },
    ok() {
      this.$refs["formData"].validate(bool => {
        if (bool) {
          this.updateStatus();
        } else {
          this.changeLoading();
        }
      });
    },
    cancel() {
      console.log(0);
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    }
  }
};
</script>

<style>
.zotalk_check .ivu-radio-wrapper {
  margin-right: 26px;
}
</style>